module.exports = __webpack_public_path__ + "static/media/SourceHanSansCN-Bold.c14e3722.svg";